import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILead, type ILeadLinkedCompany, type IPrivateCompany } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { LEAD_MODULE } from '../lead-module';
import { PRIVATE_COMPANY_MODULE } from '../private-company-module';

// Utility type to specify the nested company object
type ILeadLinkedCompanyDTO = Omit<ILeadLinkedCompany, 'company'> & { company: IPrivateCompany; lead: ILead };

export const actions: ActionTree<ILeadLinkedCompany, unknown> = {
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: Array<ILeadLinkedCompany | ILeadLinkedCompanyDTO> }) {
        const companies: IPrivateCompany[] = [];
        const leads: ILead[] = [];

        dataObjectList.forEach((linkedCompany, index, theArray) => {
            if ((linkedCompany.company ?? null) !== null && typeof linkedCompany.company !== 'number') {
                // Is a nested Company
                companies.push(linkedCompany.company);
                theArray[index].company = linkedCompany.company.dobjId;
            }

            if ((linkedCompany.lead ?? null) !== null && typeof linkedCompany.lead !== 'number') {
                // Is a nested Lead
                leads.push(linkedCompany.lead);
                theArray[index].lead = linkedCompany.lead.dobjId;
            }
        });

        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList });

        if (companies.length > 0) {
            void context.dispatch(`${PRIVATE_COMPANY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: companies }, { root: true });
        }
        if (leads.length > 0) {
            void context.dispatch(`${LEAD_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: leads }, { root: true });
        }
    }
};
